var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.57902 1.99932L14.9297 12.9993C14.9882 13.1007 15.019 13.2156 15.019 13.3326C15.019 13.4497 14.9882 13.5646 14.9297 13.666C14.8712 13.7673 14.787 13.8515 14.6857 13.91C14.5843 13.9685 14.4694 13.9993 14.3524 13.9993H1.65102C1.534 13.9993 1.41904 13.9685 1.3177 13.91C1.21635 13.8515 1.1322 13.7673 1.07369 13.666C1.01518 13.5646 0.984374 13.4497 0.984375 13.3326C0.984376 13.2156 1.01518 13.1007 1.07369 12.9993L7.42436 1.99932C7.48287 1.89798 7.56703 1.81383 7.66837 1.75532C7.76972 1.69682 7.88467 1.66602 8.00169 1.66602C8.11871 1.66602 8.23367 1.69682 8.33501 1.75532C8.43635 1.81383 8.52051 1.89798 8.57902 1.99932ZM7.33502 10.666V11.9993H8.66836V10.666H7.33502ZM7.33502 5.99932V9.33265H8.66836V5.99932H7.33502Z",
    fill: "#FF891C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.f1686e11efea5fdabc2dea5c26e1a1c7.svg";
export { ForwardRef as ReactComponent };